(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["machete-fuller-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('machete-story')) {
    customElements.define('machete-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.cards = Array.from(this.querySelectorAll('[data-machete-look]')).map(card => {
          const image = card.querySelector('[data-machete-gif]');
          const button = card.querySelector('[data-machete-toggle]');
          if (!image || !button) return null;
          button.hidden = false;
          const state = { card, image, button, visible: false, enabled: !this.motionPreference.matches };
          button.addEventListener('click', () => {
            state.enabled = !state.enabled;
            this.updateCard(state);
          }, { signal: this.controller.signal });
          return state;
        }).filter(Boolean);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const state = this.cards.find(card => card.card === entry.target);
            if (!state) return;
            state.visible = entry.isIntersecting;
            this.updateCard(state);
          });
        }, { threshold: 0.15 });
        this.cards.forEach(state => {
          this.updateCard(state);
          this.observer.observe(state.card);
        });
        this.motionPreference.addEventListener('change', event => {
          this.cards.forEach(state => {
            state.enabled = !event.matches;
            this.updateCard(state);
          });
        }, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', () => {
          this.cards.forEach(state => this.updateCard(state));
        }, { signal: this.controller.signal });
      }
      updateCard(state) {
        const playing = state.enabled && state.visible && !document.hidden;
        const source = playing ? state.image.dataset.macheteGif : state.image.dataset.macheteStill;
        if (state.image.getAttribute('src') !== source) state.image.setAttribute('src', source);
        const label = state.enabled ? state.button.dataset.pauseLabel : state.button.dataset.playLabel;
        state.button.querySelector('[data-machete-toggle-label]').textContent = label;
        state.button.setAttribute('aria-pressed', String(state.enabled));
        state.button.setAttribute('aria-label', label + ' — ' + state.button.dataset.lookTitle);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.cards?.forEach(state => {
          state.image.setAttribute('src', state.image.dataset.macheteStill);
          state.button.hidden = true;
        });
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["machete-general-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('machete-story')) {
    customElements.define('machete-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.cards = Array.from(this.querySelectorAll('[data-machete-look]')).map(card => {
          const image = card.querySelector('[data-machete-gif]');
          const button = card.querySelector('[data-machete-toggle]');
          if (!image || !button) return null;
          button.hidden = false;
          const state = { card, image, button, visible: false, enabled: !this.motionPreference.matches };
          button.addEventListener('click', () => {
            state.enabled = !state.enabled;
            this.updateCard(state);
          }, { signal: this.controller.signal });
          return state;
        }).filter(Boolean);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const state = this.cards.find(card => card.card === entry.target);
            if (!state) return;
            state.visible = entry.isIntersecting;
            this.updateCard(state);
          });
        }, { threshold: 0.15 });
        this.cards.forEach(state => {
          this.updateCard(state);
          this.observer.observe(state.card);
        });
        this.motionPreference.addEventListener('change', event => {
          this.cards.forEach(state => {
            state.enabled = !event.matches;
            this.updateCard(state);
          });
        }, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', () => {
          this.cards.forEach(state => this.updateCard(state));
        }, { signal: this.controller.signal });
      }
      updateCard(state) {
        const playing = state.enabled && state.visible && !document.hidden;
        const source = playing ? state.image.dataset.macheteGif : state.image.dataset.macheteStill;
        if (state.image.getAttribute('src') !== source) state.image.setAttribute('src', source);
        const label = state.enabled ? state.button.dataset.pauseLabel : state.button.dataset.playLabel;
        state.button.querySelector('[data-machete-toggle-label]').textContent = label;
        state.button.setAttribute('aria-pressed', String(state.enabled));
        state.button.setAttribute('aria-label', label + ' — ' + state.button.dataset.lookTitle);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.cards?.forEach(state => {
          state.image.setAttribute('src', state.image.dataset.macheteStill);
          state.button.hidden = true;
        });
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
